<template>
    <div>
        <h1>Recherche Google</h1>

        <p><b>Données</b></p>

        <b-container style="margin: 0; padding: 0; max-width: none">
            <b-row>
                <b-col>
                    Marques sans règles
                    <b-select @change="select_brand(true)" :options="brands_no_filters" v-model="brands_no_filters_selected"></b-select>
                </b-col>
                <b-col>
                    Marques avec règles
                    <b-select @change="select_brand(false)" :options="brands_filters" v-model="brands_filters_selected"></b-select>
                </b-col>
            </b-row>
        </b-container>

        <br />

        <p>Table prévalidation</p>

		<b-select v-show="false" v-model="type_data_test" :options="[
			{value: 'tabulator', text: 'Tableau'},
			{value: 'database', text: 'Base de données'},
			{value: 'DatabaseRequestView', text: 'Base de données - multitables'},
		]" />

		<div v-if="type_data_test == 'tabulator'">
			<edit_tabulator @update="import_file" ref="tabulator"></edit_tabulator>
		</div>

		<DatabaseRequestView v-if="type_data_test == 'DatabaseRequestView'"
			@update="import_file"
			_type="db"
			:minimal="true"
			ref="tabulator" />

		<div v-if="type_data_test == 'database'">
			<database
				@update="import_file"
				:change_table="false"
				:name="false"
				:edit="false"
                start_table="prevalidation"
				ref="tabulator"></database>
		</div>

        <p><b>Paramètres</b></p>

        <p>
        	<b-checkbox v-model="actif">Actif</b-checkbox>
        </p>

        <p v-show="false">
            Colonne des noms
            <b-input v-model="column_name"></b-input>
        </p>
        <p v-show="false">
            Colonne des marques
            <b-input v-model="column_brand"></b-input>
        </p>
        <p v-show="true">
            Marque où faire la recherche
            <b-input :list="'brand_list'" v-model="brand"></b-input>
            <datalist :id="'brand_list'">
                <option v-for="(option, idx) in brands" :key="idx">{{ option }}</option>
            </datalist>
        </p>
        <p v-show="false">
            Colonne des images de référence
            <b-input v-model="column_image_reference"></b-input>
        </p>

        <b-tabs>
            <b-tab title="Images">
                <p>
                    <span v-b-tooltip.hover title="Exemple : -site:amazon.fr pour exclure amazon.fr des résultats, site:amazon.com OR site:gibson.com pur ne récupérer les résuultats que de amazon.com ou gibson.com">Filtres</span>
                    <b-input v-model="filters"></b-input>
                    <span v-if="filters_db">Filtres actuels pour {{brand}} : {{filters_db}}</span>
                </p>

                <b-button @click="search()">Rechercher les images</b-button>

                <br /><br />

                <googleSearchResultsImage @add="addList" :whitelist="whitelist_image" :blacklist="blacklist_image" :column_name="column_name" :column_brand="column_brand" :column_image_reference="column_image_reference" :filters="results.filters" :data="results.results"></googleSearchResultsImage>

                <b-tabs>
                    <b-tab title="Règles">
                        <rules_block ref="rules" :columns="columns" :options="options"></rules_block>
                    </b-tab>
                    <b-tab title="Règles générales">
                        <rules_block ref="general_rules" :columns="columns" :options="options" ></rules_block>
                    </b-tab>
                </b-tabs>

                <b-button @click="test_rules()" :disabled="!results.results || results.results.length == 0">Test des règles</b-button>

                <br /><br />

                <googleSearchResultsImage @add="addList" :whitelist="whitelist_image" :blacklist="blacklist_image" :column_name="column_name" :column_brand="column_brand" :column_image_reference="column_image_reference" filters="" :data="results_rules.results"></googleSearchResultsImage>
            </b-tab>
            <b-tab title="Youtube">
                <p>
                    <span>Filtres</span>
                    <b-input v-model="filters_youtube"></b-input>
                    <span v-if="filters_db_youtube">Filtres actuels pour {{brand}} : {{filters_db_youtube}}</span>
                </p>

                <b-button @click="search_youtube()">Rechercher les vidéos Youtube</b-button>

                <br /><br />

                <googleSearchResultsYoutube @add="addList" :whitelist="whitelist_youtube" :blacklist="blacklist_youtube" :column_name="column_name" :column_brand="column_brand" :column_image_reference="column_image_reference" :filters="results_youtube.filters" :data="results_youtube.results"></googleSearchResultsYoutube>

                <b-tabs>
                    <b-tab title="Règles">
                        <rules_block ref="rules_youtube" :columns="columns_youtube" :options="options"></rules_block>
                    </b-tab>
                    <b-tab title="Règles générales">
                        <rules_block ref="general_rules_youtube" :columns="columns_youtube" :options="options" ></rules_block>
                    </b-tab>
                </b-tabs>

                <b-button @click="test_rules_youtube()" :disabled="!results_youtube.results || results_youtube.results.length == 0">Test des règles</b-button>

                <br /><br />

                <googleSearchResultsYoutube @add="addList" :whitelist="whitelist_youtube" :blacklist="blacklist_youtube" :column_name="column_name" :column_brand="column_brand" :column_image_reference="column_image_reference" filters="" :data="results_rules_youtube.results"></googleSearchResultsYoutube>
            </b-tab>
            <b-tab title="Texte">
                <div>Pour test, pas d'enregistremennt de la configuration</div>
                <googleSearchText :test_data="test_data" :column_brand="column_brand" :brand="brand" :column_name="column_name"></googleSearchText>
            </b-tab>
            <b-tab title="EAN/UPC">                
                <div>Pour test, pas d'enregistremennt de la configuration</div>
                <googleSearchEan :test_data="test_data" :column_brand="column_brand" :brand="brand" :column_name="column_name"></googleSearchEan>
            </b-tab>
        </b-tabs>

        <hr />

        <b-button @click="save">Sauvegarder la configuration</b-button>&nbsp;
        <b-button :disabled="!actif || !count_validate" @click="generate(config.project_prevalidation_validation)">Mettre en validation les produits en attente ({{count_validate}})</b-button>&nbsp;
        
        <br /><br />

        <p>Produit en validation ({{count_regenerate}})</p>

        <b-button :disabled="!actif || !count_regenerate" @click="generate(config.project_prevalidation_validation_update)">Regénérer les médias</b-button>&nbsp;
        <b-button :disabled="!actif || !count_regenerate" @click="generate(config.project_prevalidation_validation_update_rules)">Réappliquer les règles pour les médias</b-button>

        <br /><br /><br />

        <div></div>

		<div v-if="spinner" class="center_spinner">
			<fade-loader></fade-loader>
		</div>
    </div>
</template>

<script>
	var clone = require("clone");

    import FadeLoader from "vue-spinner/src/FadeLoader.vue";

	import users from "../../services/users.js";
    import workers from "../../services/workers.js";
    import database from "../../services/database.js";
    import databaseView from "../../views/database.vue";	
    import treatments from "../../services/treatments.js";
	import utils_treatments from "../../utils/treatment.js";
	import rules_block from "../../components/rules_block.vue";
    import edit_tabulator from "../../components/edit_tabulator.vue";
    import DatabaseRequestView from '../../views/DatabaseRequestView.vue';
    import googleSearchText from "../../views/green_musicians/googleSearchText.vue"
    import googleSearchEan from "../../views/green_musicians/googleSearchEan.vue"
    import googleSearchResultsImage from "../../views/green_musicians/googleSearchResultsImage.vue"
    import googleSearchResultsYoutube from "../../views/green_musicians/googleSearchResultsYoutube.vue"

    import moment from "moment";
	import * as json2csv from "json2csv";

    export default {
		components: {
			edit_tabulator,
			database: databaseView,
            DatabaseRequestView,
            googleSearchEan,
            googleSearchResultsImage,
            googleSearchResultsYoutube,
            googleSearchText,
            FadeLoader,
            rules_block
		},
		data() {
			return {
				type_data_test: "database",
				test_data: [],
                column_name: "name",
                column_brand: "marque",
                column_image_reference: "image",
                filters: "",
                results: {results: [], filters: ""},
                spinner: false,
                brands : [],
                brand: "",
                config: {},
                filters_db: "",
                filters_db_id: null,
                general_filters_db_id: null,
                options: {
					lowercase: false,
					lists: [],
                    columns_list: {}
                },
                columns: [],
                results_rules: [],
                actif: true,
                brands_filters: [],
                brands_filters_selected: "",
                brands_no_filters: [],
                brands_no_filters_selected: "",
                count_regenerate: 0,
                count_validate: 0,

                results_youtube: {results: [], filters: ""},
                columns_youtube: [],
                results_rules_youtube: [],
                filters_youtube: "",
                filters_db_youtube: "",
                filters_db_ids_youtube: null,
                general_filters_db_id_youtube: null,

                whitelist_image: [],
                blacklist_image: [],
                whitelist_youtube: [],
                blacklist_youtube: [],
            }
        },
        watch:
        {
            brand: async function()
            {
                this.filters_db = "";
                this.filters_db_id = null;
                this.$refs.rules.reset();
                this.results = {results: [], filters: ""};
                this.results_rules = []

                this.filters_db_youtube = "";
                this.filters_db_id_youtube = null;
                this.$refs.rules_youtube.reset();
                this.results_youtube = {results: [], filters: ""};
                this.results_rules_youtube = [];

                if (this.brand)
                {
                    var conditions = JSON.stringify({
                        marque: this.brand
                    })
                    var response = await database.get("select", this.config.tables_filtrers, {
                        select: "*",
                        where: 'conditions = "' + conditions.replace(/"/g, '\\"') + '" and type like "%image%"'
                    });

                    console.log(response)
                    if (response.length > 0)
                    {
                        this.actif = response[0].actif == 1 ? true : false;
                        this.filters = response[0].filtre;
                        this.filters_db = response[0].filtre;
                        this.filters_db_id = response[0].id;
                        if (response[0].rules)
                        {
                            await this.$refs.rules.load(JSON.parse(response[0].rules));
                        }
                    }
                    else
                    {
                        this.actif = true;
                        this.filters = this.brand;
                    }

                    var response = await database.get("select", this.config.tables_filtrers, {
                        select: "*",
                        where: 'conditions = "' + conditions.replace(/"/g, '\\"') + '" and type like "%youtube%"'
                    });

                    console.log(response)
                    if (response.length > 0)
                    {
                        this.filters_youtube = response[0].filtre;
                        this.filters_db_youtube = response[0].filtre;
                        this.filters_db_id_youtube = response[0].id;
                        if (response[0].rules)
                        {
                            await this.$refs.rules_youtube.load(JSON.parse(response[0].rules));
                        }
                    }
                    else
                    {
                        this.filters_youtube = this.brand;
                    }

                    var response = await database.get("select", "prevalidation", {
                        select: "count(*) as count",
                        where: 'status = "en attente" and marque = "' + this.brand +'"'
                    });

                    this.count_validate = response[0].count;

                    var response = await database.get("select", "prevalidation", {
                        select: "count(*) as count",
                        where: 'id_validation is not null and id_validation != "" and status_validation != "validé" and marque = "' + this.brand +'"'
                    });

                    this.count_regenerate = response[0].count;                 
                }
            }
        },
        methods: {
            async addList(element, type, image, youtube)
            {
                var response = await database.get("select", this.config.table_list, {
                        select: "*",
                        where: 'element = "' + element.replace(/"/g, '\\"') + '"'
                    });

                if (type)
                {
                    if (response.length == 0)
                    {
                        var response = await database.get("insert into", this.config.table_list, {
                            columns: ['marque', 'element', 'type', 'image', 'youtube'],
                            data: {
                                marque: this.brand,
                                element,
                                type,
                                image,
                                youtube
                            }
                        });
                    }

                    if (image)
                    {
                        if (type == "blacklist")
                            this.blacklist_image.push(element);
                        if (type == "whitelist")
                            this.whitelist_image.push(element);
                    }
                    if (youtube)
                    {
                        if (type == "blacklist")
                            this.blacklist_youtube.push(element);
                        if (type == "whitelist")
                            this.whitelist_youtube.push(element);
                    }
                }
                else
                {
                    for (var i = 0; i < response.length; i++)
                    {
                        var response = await database.get("delete", this.config.table_list, {
                            where: "id = '" + response[i].id + "'"
                        })
                    }

                    console.log(this.blacklist_image)

                    var index = this.blacklist_image.indexOf(element);
                    if (index != -1)
                        this.blacklist_image.splice(index, 1);
                    var index = this.whitelist_image.indexOf(element);
                    if (index != -1)
                        this.whitelist_image.splice(index, 1);
                    var index = this.blacklist_youtube.indexOf(element);
                    if (index != -1)
                        this.blacklist_youtube.splice(index, 1);
                    var index = this.whitelist_youtube.indexOf(element);
                    if (index != -1)
                        this.whitelist_youtube.splice(index, 1);

                }
            },
            async generate(project_uid)
            {
                await this.save();
                
                this.spinner = true;

                var arr = [{
                    marque: this.brand
                }]

                var str = json2csv.parse(arr, {
					fields: Object.keys(arr[0]),
					fieldNames: Object.keys(arr[0]),
					del: ",",
					quote: '"',
				});
				
				const bytes = new TextEncoder().encode(str);
				const blob = new Blob([bytes], {
					type: "text/plain",
				});

                var formData = new FormData();
                formData.append("data.csv", blob, "data.csv");
                
                var resp = await utils_treatments.test_project(
                    project_uid,
                    formData,
                    false,
                    [],
                    "",
                    true,
                    [],
                    0,
                    {},
                    {},
                    []
                ) 

                this.spinner = false;
            },
			async generate_code()
			{
				var code = await this.$refs.rules.generate_code();

				return code;
			},
			async generate_general_code()
			{
				var code = await this.$refs.general_rules.generate_code();

				return code;
			},
			async generate_code_youtube()
			{
				var code = await this.$refs.rules_youtube.generate_code();

				return code;
			},
			async generate_general_code_youtube()
			{
				var code = await this.$refs.general_rules_youtube.generate_code();

				return code;
			},
            async test_rules()
            {
                this.spinner = true;

                var data = this.results.results;
                var general_code = await this.generate_general_code();
                var code = await this.generate_code();

                code = `
                function score(data)
                {
                    ${general_code}
                    ${code};

                    if (data.image_link)
                    {
                        var host = data.image_link.replace(/(.*\\/\\/.*?\\/).*/, "$1")
                        if (blacklist.includes(host))
                        {
                            console.log("blacklist " + host)
                            data.image_score += 100;
                        }

                        if (whitelist.includes(host))
                        {
                            console.log("whitelist " + host)
                            data.image_score -= 100;
                        }
                    }

                    return data;
                }

                var blacklist = [];
                for (var i = 0; i < db.blacklist.length; i++)
                {
                    blacklist.push(db.blacklist[i].element);
                }

                var whitelist = [];
                for (var i = 0; i < db.whitelist.length; i++)
                {
                    whitelist.push(db.whitelist[i].element);
                }

                var lines = []

                for (var i = 0; i < data.length; i++)
                {
                    data[i].result = JSON.parse(data[i].result);
                
                    for (var j = 0; j < data[i].result.length; j++)
                    {
                        var line = clone(data[i]);
                        var keys = Object.keys(data[i].result[j]);
                        for (var k = 0; k < keys.length; k++)
                        {
                            line["image_" + keys[k]] = data[i].result[j][keys[k]];
                        }
                        line.image_score = line.image_position;
                        lines.push(line);
                    }
                }

                data = lines;

                for (var i = 0; i < data.length; i++)
                {
                    data[i] = score(data[i]);
                    data[i].image_score = parseInt(data[i].image_score);
                }

                data = data.sort(tools.field_sorter(["image_score"]));

                var lines = {};

                var keys = Object.keys(data[0]);
                for (var i = 0; i < data.length; i++)
                {
                    if (!lines[data[i].source + "_" + data[i].id_source])
                    {
                        lines[data[i].source + "_" + data[i].id_source] = {};
                        for (var j= 0; j < keys.length; j++)
                        {
                            if (!keys[j].startsWith("image"))
                                lines[data[i].source + "_" + data[i].id_source][keys[j]] = data[i][keys[j]];
                        }
                        lines[data[i].source + "_" + data[i].id_source].result = [];
                    }
                    var image = {};
                    for (var j = 0; j < keys.length; j++)
                    {
                        if (keys[j].startsWith("image"))
                            image[keys[j].replace("image_", "")] = data[i][keys[j]];
                    }
                    lines[data[i].source + "_" + data[i].id_source].result.push(image);
                }

                data = [];
                var keys = Object.keys(lines)
                for (var i = 0; i < keys.length; i++)
                {
                    data.push(lines[keys[i]]);
                }    
                `;

                console.log(data)

                var str_csv = json2csv.parse(data, {
					fields: Object.keys(data[0]),
					fieldNames: Object.keys(data[0]),
				});

				var files = [
					new File([str_csv], "data.csv", {
						type: "text/csv",
					}),
				];

                var formData = new FormData();
				formData.append(files[0].name, files[0]);
				formData.append("action", "fonction");
				formData.append("parameters", JSON.stringify({
						code: code,
                        type: "file",
                        db_requests: {
                            blacklist: 'select * from ' + this.config.table_list + ' where type = "blacklist" and image is true',
                            whitelist: 'select * from ' + this.config.table_list + ' where type = "whitelist" and image is true',
                        }
                }));
                
                var results = await workers.test(formData);

                var data = await treatments.getFileAlyx(
					results.data.files[0].url,
					false,
					false
				);
				let fileName = results.data.files[0].name;
                
                data = this.$papa.parse(data, { header: true });
                data = data.data;

                console.log(data)

                for (var i = 0; i < data.length; i++)
                {
                    data[i].result = JSON.parse(data[i].result);
                }

                this.results_rules = {results: data};

                this.spinner = false;                
            },
            async test_rules_youtube()
            {
                this.spinner = true;

                var data = this.results_youtube.results;
                var general_code = await this.generate_general_code_youtube();
                var code = await this.generate_code_youtube();

                code = `
                function score(data)
                {
                    ${general_code}
                    ${code};

                    if (blacklist.includes(data.youtube_channel_link))
                    {
                        console.log("blacklist " + data.youtube_channel_link)
                        data.youtube_score += 100;
                    }

                    if (whitelist.includes(data.youtube_channel_link))
                    {                        
                        console.log("whitelist " + data.youtube_channel_link)
                        data.youtube_score -= 100;
                    }

                    return data;
                }

                var blacklist = [];
                for (var i = 0; i < db.blacklist.length; i++)
                {
                    blacklist.push(db.blacklist[i].element);
                }

                var whitelist = [];
                for (var i = 0; i < db.whitelist.length; i++)
                {
                    whitelist.push(db.whitelist[i].element);
                }

                var lines = []

                for (var i = 0; i < data.length; i++)
                {
                    data[i].result = JSON.parse(data[i].result);
                
                    for (var j = 0; j < data[i].result.length; j++)
                    {
                        var line = clone(data[i]);
                        var keys = Object.keys(data[i].result[j]);
                        for (var k = 0; k < keys.length; k++)
                        {
                            line["youtube_" + keys[k]] = data[i].result[j][keys[k]];
                        }
                        line.youtube_score = line.youtube_position;
                        lines.push(line);
                    }
                }

                data = lines;

                for (var i = 0; i < data.length; i++)
                {
                    data[i] = score(data[i]);
                    data[i].youtube_score = parseInt(data[i].youtube_score);
                }

                data = data.sort(tools.field_sorter(["youtube_score"]));

                var lines = {};

                var keys = Object.keys(data[0]);
                for (var i = 0; i < data.length; i++)
                {
                    if (!lines[data[i].source + "_" + data[i].id_source])
                    {
                        lines[data[i].source + "_" + data[i].id_source] = {};
                        for (var j= 0; j < keys.length; j++)
                        {
                            if (!keys[j].startsWith("youtube"))
                                lines[data[i].source + "_" + data[i].id_source][keys[j]] = data[i][keys[j]];
                        }
                        lines[data[i].source + "_" + data[i].id_source].result = [];
                    }
                    var youtube = {};
                    for (var j = 0; j < keys.length; j++)
                    {
                        if (keys[j].startsWith("youtube"))
                            youtube[keys[j].replace("youtube_", "")] = data[i][keys[j]];
                    }
                    lines[data[i].source + "_" + data[i].id_source].result.push(youtube);
                }

                data = [];
                var keys = Object.keys(lines)
                for (var i = 0; i < keys.length; i++)
                {
                    data.push(lines[keys[i]]);
                }    
                `;

                console.log(data)

                var str_csv = json2csv.parse(data, {
					fields: Object.keys(data[0]),
					fieldNames: Object.keys(data[0]),
				});

				var files = [
					new File([str_csv], "data.csv", {
						type: "text/csv",
					}),
				];

                var formData = new FormData();
				formData.append(files[0].name, files[0]);
				formData.append("action", "fonction");
				formData.append("parameters", JSON.stringify({
						code: code,
						type: "file",
                        db_requests: {
                            blacklist: 'select * from ' + this.config.table_list + ' where type = "blacklist" and youtube is true',
                            whitelist: 'select * from ' + this.config.table_list + ' where type = "whitelist" and youtube is true',
                        }
                }));
                
                var results = await workers.test(formData);

                var data = await treatments.getFileAlyx(
					results.data.files[0].url,
					false,
					false
				);
				let fileName = results.data.files[0].name;
                
                data = this.$papa.parse(data, { header: true });
                data = data.data;

                console.log(data)

                for (var i = 0; i < data.length; i++)
                {
                    data[i].result = JSON.parse(data[i].result);
                }

                this.results_rules_youtube = {results: data};

                this.spinner = false;                
            },
            async save()
            {
                if (this.actif)
                {
                    for (var i = 0; i < this.brands_no_filters.length; i++)
                    {
                        if (this.brands_no_filters[i].value == this.brand)
                        {
                            if (this.brands_filters.includes(this.brand))
                                this.brands_filters.push(this.brand);
                            break;
                        }
                    }
                }

                /* image */

                var code = await this.generate_code();
                var rules = this.$refs.rules.save();

                var general_code = await this.generate_general_code();
                var general_rules = this.$refs.general_rules.save();
                
                if (!this.filters_db_id)
                {
                    var response = await database.get("insert into", this.config.tables_filtrers, {
                        columns: ['filtre', 'conditions', 'type', 'rules', 'code', 'actif'],
                        data: {
                            filtre: this.filters,
                            conditions: JSON.stringify({
                                marque: this.brand
                            }),
                            type: JSON.stringify(["image"]),
                            code: code,
                            rules: JSON.stringify(rules),
                            actif: this.actif ? 1 : 0
                        }
                    });

                    if (response.insertId)
                    {
                        this.filters_db = this.filters;
                        this.filters_db_id = response.insertId;
                    }
                }
                else
                {
                    var response = await database.get("update", this.config.tables_filtrers, {
                        columns: ['filtre', 'conditions', 'type', 'code', 'rules', 'actif'],
                        set: 'actif = ' + (this.actif ? 1 : 0) + ', rules = "' + JSON.stringify(rules).replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '", code = "' + code.replace(/"/g, '\\"') + '", filtre = "' + this.filters.replace(/"/g, '\\"') + '"',
                        where: 'id = ' + this.filters_db_id
                    });
                    this.filters_db = this.filters;
                }

                if (!this.general_filters_db_id)
                {
                    var response = await database.get("insert into", this.config.tables_filtrers, {
                        columns: ['conditions', 'type', 'code', 'rules'],
                        data: {
                            conditions: "",
                            type: JSON.stringify(["image"]),
                            code: general_code,
                            rules: JSON.stringify(general_rules)
                        }
                    });

                    if (response.insertId)
                    {
                        this.general_filters_db_id = response.insertId;
                    }
                }
                else
                {
                    var response = await database.get("update", this.config.tables_filtrers, {
                        columns: ['conditions', 'type', 'code', 'rules'],
                        set: 'rules = "' + JSON.stringify(general_rules).replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '", code = "' + general_code.replace(/"/g, '\\"') + '"',
                        where: 'id = ' + this.general_filters_db_id
                    });
                }

                /* Youtube */

                var code = await this.generate_code_youtube();
                var rules = this.$refs.rules_youtube.save();

                var general_code = await this.generate_general_code_youtube();
                var general_rules = this.$refs.general_rules_youtube.save();
                
                if (!this.filters_db_id_youtube)
                {
                    var response = await database.get("insert into", this.config.tables_filtrers, {
                        columns: ['filtre', 'conditions', 'type', 'rules', 'code', 'actif'],
                        data: {
                            filtre: this.filters_youtube,
                            conditions: JSON.stringify({
                                marque: this.brand
                            }),
                            type: JSON.stringify(["youtube"]),
                            code: code,
                            rules: JSON.stringify(rules),
                            actif: this.actif ? 1 : 0
                        }
                    });

                    if (response.insertId)
                    {
                        this.filters_db_youtube = this.filters_youtube;
                        this.filters_db_id_youtube = response.insertId;
                    }
                }
                else
                {
                    var response = await database.get("update", this.config.tables_filtrers, {
                        columns: ['filtre', 'conditions', 'code', 'rules', 'actif'],
                        set: 'actif = ' + (this.actif ? 1 : 0) + ', rules = "' + JSON.stringify(rules).replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '", code = "' + code.replace(/"/g, '\\"') + '", filtre = "' + this.filters_youtube.replace(/"/g, '\\"') + '"',
                        where: 'id = ' + this.filters_db_id_youtube
                    });
                    this.filters_db_youtube = this.filters_youtube;
                }

                if (!this.general_filters_db_id_youtube)
                {
                    var response = await database.get("insert into", this.config.tables_filtrers, {
                        columns: ['conditions', 'type', 'code', 'rules'],
                        data: {
                            conditions: "",
                            type: JSON.stringify(["youtube"]),
                            code: general_code,
                            rules: JSON.stringify(general_rules)
                        }
                    });

                    if (response.insertId)
                    {
                        this.general_filters_db_id_youtube = response.insertId;
                    }
                }
                else
                {
                    var response = await database.get("update", this.config.tables_filtrers, {
                        columns: ['code', 'rules'],
                        set: 'rules = "' + JSON.stringify(general_rules).replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '", code = "' + general_code.replace(/"/g, '\\"') + '"',
                        where: 'id = ' + this.general_filters_db_id_youtube
                    });
                }
            },
			import_file()
			{
                console.log("import_file")
				this.test_data = this.$refs.tabulator.get_data();
                this.test_data = clone(this.test_data)

                this.brands = [];
				if (this.test_data.length > 0)
				{
                    this.columns = Object.keys(this.test_data[0]);
                    this.columns.push();
                    this.columns.push("image_position"); 
                    this.columns.push("image_source");
                    this.columns.push("image_title");
                    this.columns.push("image_link");
                    this.columns.push("image_url");
                    this.columns.push("image_width");
                    this.columns.push("image_height");
                    this.columns.push("image_is_product");
                    this.columns.push("image_get_date");
                    this.columns.push("image_ref");
                    this.columns.push("image_score");

                    this.columns_youtube = Object.keys(this.test_data[0]);
                    this.columns_youtube.push();
                    this.columns_youtube.push("youtube_position");
                    this.columns_youtube.push("youtube_title");
                    this.columns_youtube.push("youtube_url");
                    this.columns_youtube.push("youtube_channel_name");
                    this.columns_youtube.push("youtube_channel_link");
                    this.columns_youtube.push("youtube_channel_verified");
                    this.columns_youtube.push("youtube_description");
                    this.columns_youtube.push("youtube_published_date");
                    this.columns_youtube.push("youtube_views");
                    this.columns_youtube.push("youtube_length");
                    this.columns_youtube.push("youtube_extensions");
                    this.columns_youtube.push("youtube_thumbnail_static");
                    this.columns_youtube.push("youtube_thumbnail_rich");
                    this.columns_youtube.push("youtube_score");

                    var keys = Object.keys(this.test_data[0]);
                    for (var i = 0; i < keys.length; i++)
                    {
                        if (keys[i] == "nom_en")
                            this.column_name = "nom_en";
                        if (keys[i] == "url_image_reference")
                            this.column_image_reference = "url_image_reference";
                        
                    }
					for (var i = 0; i < this.test_data.length; i++)
                    {
                        if (this.test_data[i][this.column_brand])
                        {
                            if (i == 0)
                                this.brand = this.test_data[i][this.column_brand];
                            if (!this.brands.includes(this.test_data[i][this.column_brand]))    
                                this.brands.push(this.test_data[i][this.column_brand])
                        }
                    }
				}
				else
				{
				}
            },
            async search(filters)
            {
                this.spinner = true;

                var data = await this.$refs.tabulator.get_data();
                data = clone(data)

                for (var i = 0; i < data.length; i++)
                {
                    if (data[i][this.column_brand] != this.brand)
                    {
                        data.splice(i, 1);
                        i--;
                    }
                }

                data = data.slice(0, 10);

                var str_csv = json2csv.parse(data, {
					fields: Object.keys(data[0]),
					fieldNames: Object.keys(data[0]),
				});

				var files = [
					new File([str_csv], "data.csv", {
						type: "text/csv",
					}),
				];

				var formData = new FormData();
				formData.append(files[0].name, files[0], "data.csv");
				formData.append("action", "api");

                var request = {
                    column_result: "result",
                    column_error: "error",
                    unique: false,
                    uri: "https://serpapi.com/search",
                    qs: [
                        ""
                    ],
                    qs_params: {
                        api_key: "serpapi_key",
                        engine: "google_images",
                        "q": "${data['" + this.column_name + "']} " + this.filters
                    },
                    options_template: true
                }

                formData.append("parameters", JSON.stringify(request));

                var results = await workers.test(formData);

                var data = await treatments.getFileAlyx(
					results.data.files[0].url,
					false,
					false
				);
				let fileName = results.data.files[0].name;
                
                data = this.$papa.parse(data, { header: true });
                data = data.data;                

                for (var i = 0; i < data.length; i++)
                {
                    data[i].result = JSON.parse(data[i].result);
                    var urls_image = [];
                    console.log(data[i])
                    if (data[i].result && data[i].result.images_results)
                    {
                        for (var j = 0; j < data[i].result.images_results.length && j < 100; j++)
                        {
                            urls_image.push({
                                id: this.$uuid.v4(),
                                position: data[i].result.images_results[j].position,
                                source: data[i].result.images_results[j].source,
                                title: data[i].result.images_results[j].title,
                                link: data[i].result.images_results[j].link,
                                url: data[i].result.images_results[j].original,
                                width: data[i].result.images_results[j].original_width,
                                height: data[i].result.images_results[j].original_height,
                                is_product: data[i].result.images_results[j].is_product,
                                get_date: moment().format("YYYY-MM-DD"),
                                ref: data[i][this.column_image_reference],
                                score: data[i].result.images_results[j].position
                            });
                        }
                    }
                    data[i].result = urls_image;
                }

                this.results = {filters, results: data};

                await this.test_rules()

                this.spinner = false;
            },
            async search_youtube(filters)
            {
                this.spinner = true;

                var data = await this.$refs.tabulator.get_data();
                data = clone(data)

                for (var i = 0; i < data.length; i++)
                {
                    if (data[i][this.column_brand] != this.brand)
                    {
                        data.splice(i, 1);
                        i--;
                    }
                }

                data = data.slice(0, 10);

                var str_csv = json2csv.parse(data, {
					fields: Object.keys(data[0]),
					fieldNames: Object.keys(data[0]),
				});

				var files = [
					new File([str_csv], "data.csv", {
						type: "text/csv",
					}),
				];

				var formData = new FormData();
				formData.append(files[0].name, files[0], "data.csv");
				formData.append("action", "api");

                var request = {
                    column_result: "result",
                    column_error: "error",
                    unique: false,
                    uri: "https://serpapi.com/search",
                    qs: [
                        ""
                    ],
                    qs_params: {
                        api_key: "serpapi_key",
                        engine: "youtube",
                        "search_query": "${data['" + this.column_name + "']} " + this.filters_youtube
                    },
                    options_template: true
                }

                formData.append("parameters", JSON.stringify(request));

                var results = await workers.test(formData);

                var data = await treatments.getFileAlyx(
					results.data.files[0].url,
					false,
					false
				);
				let fileName = results.data.files[0].name;
                
                data = this.$papa.parse(data, { header: true });
                data = data.data;                

                for (var i = 0; i < data.length; i++)
                {
                    data[i].result = JSON.parse(data[i].result);
                    var urls_youtube = [];
                    console.log(data[i])
                    if (data[i].result && data[i].result.video_results)
                    {
                        for (var j = 0; j < data[i].result.video_results.length && j < 100; j++)
                        {
                            urls_youtube.push({
                                id: this.$uuid.v4(),
                                position: data[i].result.video_results[j].position_on_page,
                                title: data[i].result.video_results[j].title.replace(/\\/, ""),
                                url: data[i].result.video_results[j].link,
                                channel_name: data[i].result.video_results[j].channel.name,
                                channel_link: data[i].result.video_results[j].channel.link,
                                channel_verified: data[i].result.video_results[j].channel.verified,
                                description: data[i].result.video_results[j].description,
                                published_date: data[i].result.video_results[j].published_date,
                                views: data[i].result.video_results[j].views,
                                length: data[i].result.video_results[j].length,
                                extensions: data[i].result.video_results[j].extensions,
                                thumbnail_static: data[i].result.video_results[j].thumbnail.static,
                                thumbnail_rich: data[i].result.video_results[j].thumbnail.rich,
                                get_date: moment().format("YYYY-MM-DD"),
                                ref: data[i][this.column_image_reference],
                                score: data[i].result.video_results[j].position_on_page
                            });
                        }
                    }
                    data[i].result = urls_youtube;
                }

                this.results_youtube = {filters, results: data};

                await this.test_rules_youtube()

                this.spinner = false;
            },
            async select_brand(wait)
            {
                if (wait)
                {
                    this.brands_filters_selected = "";
                }
                else
                {
                    this.brands_no_filters_selected = "";
                }

                if (this.type_data_test == "database")
                {
                    var data = {
                        table: "prevalidation",
                        event: "no limit",
                        columns_selected: []
                    };
                    data.rules =  {
                        "condition": "AND",
                        "rules": [
                            {
                                "id": "`marque`",
                                "field": "`marque`",
                                "type": "string",
                                "input": "text",
                                "operator": "equal",
                                "value": this.brands_filters_selected || this.brands_no_filters_selected
                            }
                        ],
                        "valid": true
                    };

                    if (wait)
                    {
                        data.rules.rules.push(
                            {
                                "id": "`status`",
                                "field": "`status`",
                                "type": "string",
                                "input": "text",
                                "operator": "equal",
                                "value": "en attente"
                            });
                    }

                    await this.$refs.tabulator.load(data);
                }
            }
        },
		mounted: async function () {

            var self = this;

			var response = await users.getSelf(true);
			let client = response.client;

            if (!(client.details && client.details.pages && client.details.pages.green_musicians && client.details.pages.green_musicians.active))
            {
                this.$router.push({ name: "profile" });
            }

            if (client.details && client.details.pages && client.details.pages.green_musicians)
            {
                this.config = client.details.pages.green_musicians;
            }

            response = await database.get("select", this.config.tables_filtrers, {
                select: "*",
                where: 'conditions = "" and type like "%image%"'
            });

            if (response.length > 0)
            {
                this.general_filters_db_id = response[0].id;
                if (response[0].rules)
                {
                    this.$refs.general_rules.load(JSON.parse(response[0].rules));
                }
            }

            response = await database.get("select", this.config.tables_filtrers, {
                select: "*",
                where: 'conditions = "" and type like "%youtube%"'
            });

            if (response.length > 0)
            {
                this.general_filters_db_id_youtube = response[0].id;
                if (response[0].rules)
                {
                    this.$refs.general_rules_youtube.load(JSON.parse(response[0].rules));
                }
            }

            var nb_products_brands = await database.get("select", "prevalidation", {
                select: "count(*) as nb_products, marque",
                where: 'status = "en attente" group by marque order by nb_products desc'
            });

            var nb_products_brands_validation = await database.get("select", "prevalidation", {
                select: "count(*) as nb_products, marque",
                where: 'status = "en attente" or (id_validation is not null and id_validation != "" and status_validation != "validé") group by marque order by nb_products desc'
            });

            response = await database.get("select", this.config.tables_filtrers, {
                select: "conditions",
                where: 'actif = 1 group by conditions order by conditions'
            });

            var brands_filters = [];
            for (var i = 0; i < response.length; i++)
            {
                var brand = response[i].conditions.replace(/{"marque":"/, "").replace(/"}/, "")
                if (brand)
                {
                    brands_filters.push(brand)
                }
            }

            console.log("brands_filters")
            console.log(brands_filters)

            this.brands_filters = [];
            for (var i = 0; i < nb_products_brands_validation.length; i++)
            {
                if (brands_filters.includes(nb_products_brands_validation[i].marque))
                {
                    this.brands_filters.push({
                        value: nb_products_brands_validation[i].marque,
                        text: nb_products_brands_validation[i].nb_products + " - " + nb_products_brands_validation[i].marque
                    });
                }
            }

            this.brands_no_filters = [];
            for (var i = 0; i < nb_products_brands.length; i++)
            {
                if (!brands_filters.includes(nb_products_brands[i].marque))
                {
                    this.brands_no_filters.push({
                        value: nb_products_brands[i].marque,
                        text: nb_products_brands[i].nb_products + " - " + nb_products_brands[i].marque
                    });
                }
            }

            response = await database.get("select", this.config.table_list, {
                select: "*",
                where: 'type = "blacklist" and image is true'
            });

            for (var i = 0; i < response.length; i++)
            {
                this.blacklist_image.push(response[i].element);
            }

            response = await database.get("select", this.config.table_list, {
                select: "*",
                where: 'type = "whitelist" and image is true'
            });

            for (var i = 0; i < response.length; i++)
            {
                this.whitelist_image.push(response[i].element);
            }

            response = await database.get("select", this.config.table_list, {
                select: "*",
                where: 'type = "blacklist" and youtube is true'
            });

            for (var i = 0; i < response.length; i++)
            {
                this.blacklist_youtube.push(response[i].element);
            }

            response = await database.get("select", this.config.table_list, {
                select: "*",
                where: 'type = "whitelist" and youtube is true'
            });

            for (var i = 0; i < response.length; i++)
            {
                this.whitelist_youtube.push(response[i].element);
            }
        }
    }
</script>

<style scoped>
	.center_spinner {
		width: 0%;
		margin: 0 auto;
        margin-bottom: 60px;
	}
    .table-striped > tbody > tr:nth-child(2n+1) > td, .table-striped > tbody > tr:nth-child(2n+1) > th {
        background-color: WhiteSmoke;
    }
</style>